import { registerEnum } from '@adornis/baseql/metadata/register.js';
import { type SalaryTableLevels, allSalaryTableLevels } from './SalaryTableLevels.js';

export enum SalaryTableRowKeys {
  E15UE = 'E15UE',
  E15 = 'E15',
  E14 = 'E14',
  E13 = 'E13',
  E12 = 'E12',
  E11 = 'E11',
  E10 = 'E10',
  E9C = 'E9C',
  E9B = 'E9B',
  E9A = 'E9A',
  E8 = 'E8',
  E7 = 'E7',
  E6 = 'E6',
  E5 = 'E5',
  E4 = 'E4',
  E3 = 'E3',
  E2UE = 'E2UE',
  E2 = 'E2',
  E1 = 'E1',
}
registerEnum({ enum: SalaryTableRowKeys, name: 'SalaryTableRowKeys' });

/**
 * As a baseQL enum has more than the basic keys attached to it we need to filter them out before using them.
 * @returns
 */
export function allSalaryTableRowKeys() {
  return Object.values(SalaryTableRowKeys).filter(t => !['SalaryTableRowKeys', true].includes(t));
}

export function getSalaryRowLevelIndex(targetLevel: SalaryTableLevels) {
  return allSalaryTableLevels().indexOf(targetLevel);
}
